import React from "react";

const SvgComponent = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    height={579.681}
    width={544.023}
    version={1}
    {...props}
  >
    <defs>
      <linearGradient id="a">
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        xlinkHref="#a"
        id="e"
        gradientUnits="userSpaceOnUse"
        x1={14.921}
        y1={257.855}
        x2={105.523}
        y2={378.969}
        gradientTransform="translate(-2579.229 420.686)"
      />
      <linearGradient id="b">
        <stop offset={0} stopColor="#484848" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        xlinkHref="#b"
        id="d"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(4.13318 0 0 4.13318 12930.34 1387.599)"
        x1={-3723.153}
        y1={-209.318}
        x2={-3647.661}
        y2={-40.623}
      />
      <linearGradient id="c">
        <stop offset={0} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
    </defs>
    <path
      d="M-2420.831 629.968l313.604 1.043c78.374 43.485 233.116 156.754 233.798 222.435l2.088 513.416h-549.49V629.968z"
      style={{ marker: "none" }}
      color="#000"
      fill="url(#d)"
      stroke="#a4a4a4"
      strokeWidth={24.452}
      display="block"
      overflow="visible"
      transform="matrix(.76139 0 0 .76139 1959.533 -470.342)"
    />
    <path
      d="M176.278 511.749c15.444 57.36 161.251-78.628 227.905-294.097 20.82-72.562-32.6-56.551-36.582-3.193-12.723 170.512 75.243 313.829 109.354 282.929 45.574-32.333-57.474-80.18-129.603-70.945-34.861 4.464-186.833 25.63-171.074 85.306z"
      fill="none"
      stroke="#000"
      strokeWidth={33.35954146}
      strokeOpacity={0.181}
    />
    <path
      d="M164.325 502.304c15.444 57.36 161.252-78.628 227.906-294.098 20.82-72.561-32.6-56.55-36.582-3.193-12.724 170.512 75.242 313.83 109.354 282.93 45.573-32.334-57.475-80.181-129.604-70.946-34.861 4.464-186.833 25.631-171.074 85.307z"
      fill="none"
      stroke="#f10000"
      strokeWidth={11.27923146}
    />
    <path
      d="M12.43 55.579h317.609c6.91 37.614 6.21 118.222 0 154.731H12.429c-8.57-38.594-7.71-121.256 0-154.731z"
      style={{ marker: "none" }}
      color="#000"
      fill="#f70000"
      stroke="#ca0000"
      strokeWidth={12.639074}
      display="block"
      overflow="visible"
    />
    <text
      style={{ textAlign: "start", lineHeight: "125%", marker: "none" }}
      x={-2782.514}
      y={784.715}
      transform="matrix(.6819 0 0 .85015 1959.533 -470.342)"
      fontSize={167.264}
      fontWeight={700}
      color="#000"
      fillOpacity={0.275}
      display="block"
      overflow="visible"
      fontFamily="Bitstream Vera Sans"
    >
      <tspan x={-2782.514} y={784.715}>
        PDF
      </tspan>
    </text>
    <text
      transform="matrix(.68751 0 0 .8432 1959.533 -470.342)"
      y={778.25}
      x={-2777.882}
      style={{ textAlign: "start", lineHeight: "125%", marker: "none" }}
      fontSize={165.14}
      fontWeight={700}
      color="#000"
      fill="#fff"
      display="block"
      overflow="visible"
      fontFamily="Bitstream Vera Sans"
    >
      <tspan y={778.25} x={-2777.882}>
        PDF
      </tspan>
    </text>
    <path
      d="M369.452 43.043s20.755 33.455 41.632 97.934c98.068-27.073 115.53 6.198 115.53 6.198-22.252-63.578-138.089-99.364-157.162-104.132z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      d="M-2552.086 700.19l163.634 1.208-35.349 146.528-133.285-10.02c-2.45-36.246-3.676-82.527 5-137.715z"
      style={{ marker: "none" }}
      color="#000"
      fill="url(#e)"
      display="block"
      overflow="visible"
      transform="matrix(.76139 0 0 .76139 1959.533 -470.342)"
    />
  </svg>
);

export default __webpack_public_path__ +
  "static/media/adobe-pdf-icon.a3a0582f.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/img/adobe-pdf-icon.svg